import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { PagesAuthConfigResponse, UserDetails } from "../../interfaces/user.interface";
import { ProgramService } from "../../services/program.service";
import { UserService } from "../../services/user.service";
import { AuthorizationConfig } from "./auth.config";

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    private authConfig: AuthorizationConfig;

    public constructor(private userService: UserService,
        private programService: ProgramService) {
        const userDetails = this.userService.getUserDetails();
        if (userDetails) {
            this.authConfig = {
                restrictedRoutes: this.removeDuplicates(userDetails.restrictedRoutes),
                pageAuthorization: userDetails.pageAuthorization
            }
        } else {
            this.authConfig = {
                restrictedRoutes: []
            };
        }
    }

    public getAuthorizationConfig() {
        return this.authConfig;
    }

    public fetchPageAuthorization(programCode: string, pageId: string, pageType: string): Observable<any> {
        return this.programService.fetchPageAuthorization(programCode, [pageId], pageType).pipe(
            map(response => {
                if (response) {
                    const pageConfig = this.loadPageConfiguration(pageId, response);
                    return pageConfig
                }

                return {};
            }));
    }

    private removeDuplicates(arr: string[]) {
        return arr.filter((item,
            index) => arr.indexOf(item) === index);
    }

    private loadPageConfiguration(pageId: string, response: PagesAuthConfigResponse) {
        const userDetails = this.userService.getUserDetails();
        if (userDetails) {
            let pageConfig = {};
            response.responsedata.forEach(response => {
                if (!userDetails.pageAuthorization) {
                    userDetails.pageAuthorization = {};
                }
                userDetails.pageAuthorization[response.pageName] = response;
                if (response.pageName.toLocaleLowerCase() == pageId.toLocaleLowerCase()) {
                    pageConfig = response;
                }
            });

            this.userService.setUserDetails(userDetails);
            return pageConfig
        }

        // should not return here
        return {};
    }
}